import {
  FETCH_CLASSRECORDS,
  FETCH_CLASSRECORD,
  SUBMIT_CLASSRECORD,
  LOADING_CLASSRECORDS,
  DELETE_CLASSRECORD
} from "../actions/type";

const INIT_STATE = {
  classRecords: [],
  classRecordMap: {},
  pagination: null,
  isLoadingClassRecords: false
};

export default (state = INIT_STATE, { type, payload }) => {
  switch (type) {
    case FETCH_CLASSRECORDS:
      return {
        ...state,
        classRecords: payload.classRecords,
        classRecordMap: payload.classRecords.reduce((map, item) => {
          map[item._id] = item;
          return map;
        }, {}),
        pagination: payload.pagination
      };

    case FETCH_CLASSRECORD:
    case SUBMIT_CLASSRECORD:
      if (!payload.classRecord || !payload.classRecord._id) {
        console.error("Invalid classRecord payload:", payload);
        return state;
      }
      return {
        ...state,
        classRecordMap: {
          ...state.classRecordMap,
          [payload.classRecord._id]: payload.classRecord
        }
      };

    case DELETE_CLASSRECORD:
      const newClassRecordMap = { ...state.classRecordMap };
      delete newClassRecordMap[payload.classRecordId];

      return {
        ...state,
        classRecords: state.classRecords.filter(
          (record) => record._id !== payload.classRecordId
        ),
        classRecordMap: newClassRecordMap
      };

    case LOADING_CLASSRECORDS:
      return {
        ...state,
        isLoadingClassRecords: payload
      };

    default:
      return state;
  }
};
